import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, ElementRef, ViewChild} from '@angular/core';
import {UsersService} from '../../../shared/services/users.service';
import {NotificationsService} from '../../../shared/services/notification.service';
import {LocalisationService} from '../../../shared/services/localisation.service';
import {MinutesToReadableTimePipe} from '../../../shared/pipes/minutesToReadableTime.pipe';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService} from '../../../shared/services/master.service';

@Component({
    selector: 'app-master-inbody',
    templateUrl: './inbody.component.html',
    styleUrls: ['./inbody.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class MasterInBodyComponent implements OnInit {
    @Input() id;
    @ViewChild('inputFile') myInputVariable: ElementRef;

    constructor(
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly notificationService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly minutesToReadableTimePipe: MinutesToReadableTimePipe,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly masterService: MasterService,
    ) {
    }

    ngOnInit() {

    }

    handleFileInput($event: Event) {
        // @ts-ignore
        const file = $event.target.files.item(0);

        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.masterService.uploadInBodyXlsxFile(this.id, file).subscribe(result => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.notificationService.success(this.localisationService.localise('inbody_files_uploaded'));
        }, () => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.notificationService.error(this.localisationService.localise('inbody_fail'));
        });

        this.myInputVariable.nativeElement.value = '';
    }

}
